module.exports = __webpack_public_path__ + "img/checklist.0102b079.svg";